import { cn } from '~/lib/utils';

interface LogoProps {
  className?: string;
}

export const Home = ({ className }: LogoProps) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(!!className && className)}
    >
      <path
        d="M20.7852 10C20.7852 9.72386 20.5613 9.5 20.2852 9.5C20.009 9.5 19.7852 9.72386 19.7852 10H20.7852ZM20.2852 22V22.5C20.5613 22.5 20.7852 22.2761 20.7852 22H20.2852ZM4.28516 22H3.78516C3.78516 22.2761 4.00901 22.5 4.28516 22.5V22ZM4.78516 10C4.78516 9.72386 4.5613 9.5 4.28516 9.5C4.00901 9.5 3.78516 9.72386 3.78516 10H4.78516ZM12.2852 2L12.6387 1.64645C12.4434 1.45118 12.1269 1.45118 11.9316 1.64645L12.2852 2ZM2.9316 10.6464C2.73634 10.8417 2.73634 11.1583 2.9316 11.3536C3.12686 11.5488 3.44345 11.5488 3.63871 11.3536L2.9316 10.6464ZM20.9316 11.3536C21.1269 11.5488 21.4434 11.5488 21.6387 11.3536C21.834 11.1583 21.834 10.8417 21.6387 10.6464L20.9316 11.3536ZM19.7852 10V22H20.7852V10H19.7852ZM20.2852 21.5H4.28516V22.5H20.2852V21.5ZM4.78516 22V10H3.78516V22H4.78516ZM10.7852 22V16H9.78516V22H10.7852ZM11.2852 15.5H13.2852V14.5H11.2852V15.5ZM13.7852 16V22H14.7852V16H13.7852ZM13.2852 15.5C13.5613 15.5 13.7852 15.7239 13.7852 16H14.7852C14.7852 15.1716 14.1136 14.5 13.2852 14.5V15.5ZM10.7852 16C10.7852 15.7239 11.009 15.5 11.2852 15.5V14.5C10.4567 14.5 9.78516 15.1716 9.78516 16H10.7852ZM11.9316 1.64645L2.9316 10.6464L3.63871 11.3536L12.6387 2.35355L11.9316 1.64645ZM11.9316 2.35355L20.9316 11.3536L21.6387 10.6464L12.6387 1.64645L11.9316 2.35355Z"
        fill="#646464"
      />
    </svg>
  );
};
